import { IonContent } from "@ionic/react";
import HeaderComponent from "../components/HeaderComponent";

const Alerts: React.FC = () => {
  return (
    <IonContent fullscreen>
      <HeaderComponent title={"Alerts"} />
      <h2>alerts page</h2>
    </IonContent>
  );
};

export default Alerts;
